<template>
  <div class="error-page-component">
    <div class="error-page-container">
      <img
        class="background"
        alt=""
        :src="getImageUrl"
      />
      <div class="ai-block">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M9.41467 6.58659C10.1953 7.36725 10.1953 8.63459 9.41467 9.41659C8.634 10.1973 7.36667 10.1973 6.58467 9.41659C5.804 8.63592 5.804 7.36859 6.58467 6.58659C7.36667 5.80459 8.63333 5.80459 9.41467 6.58659Z"
            stroke="white"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2 7.99992C2 7.56059 2.10133 7.12592 2.29733 6.72525C3.30733 4.66059 5.53933 3.33325 8 3.33325C10.4607 3.33325 12.6927 4.66059 13.7027 6.72525C13.8987 7.12592 14 7.56059 14 7.99992C14 8.43925 13.8987 8.87392 13.7027 9.27459C12.6927 11.3393 10.4607 12.6666 8 12.6666C5.53933 12.6666 3.30733 11.3393 2.29733 9.27459C2.10133 8.87392 2 8.43925 2 7.99992Z"
            stroke="white"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span>Изображение сгенерировано ИИ</span>
      </div>
      <div class="info-block">
        <div class="title">{{ titleInfo }}</div>
        <div
          class="message"
          v-html="messageInfo"
        ></div>
        <SButton
          v-show="false"
          variant="primary"
          class="button"
          @click="btnHandler"
          >{{ btnInfo }}</SButton
        >
      </div>
    </div>
  </div>
</template>

<script>
import { SButton } from '@synergy/ui-kit-vue3';

export default {
  name: 'ErrorPage',
  components: {
    SButton,
  },
  data() {
    return {
      isErrorPage: true,
      indexImage: 1,
      windowWidth: 1920,
    };
  },
  computed: {
    titleInfo() {
      return this.isErrorPage ? 'Что-то пошло не так' : 'Страница не найдена';
    },
    messageInfo() {
      return this.isErrorPage
        ? 'Такой страницы не существует.'
        : 'Попробуйте перезагрузить страницу и <br> проверьте подключение к интернету.';
    },
    btnInfo() {
      return this.isErrorPage ? 'Хорошо' : 'Вернуться на главную';
    },
    getFolderName() {
      if (this.windowWidth >= 1920) {
        return 'big_desktop';
      } else if (this.windowWidth < 1920 && this.windowWidth >= 1366) {
        return 'desktop';
      } else if (this.windowWidth < 1366 && this.windowWidth >= 744) {
        return 'tablet';
      } else {
        return 'mobile';
      }
    },
    getImageUrl() {
      const folder = this.getFolderName;
      return `/images/not_found/${folder}/${this.indexImage}.png`;
    },
  },
  methods: {
    resizeWindowEventHandler() {
      this.windowWidth = window?.innerWidth || 1920;
    },
    randomImageIndex() {
      // c 1 по 4 - ошибки, с 5 по 8 - 404
      this.indexImage = this.isErrorPage
        ? Math.floor(Math.random() * 4) + 1
        : Math.floor(Math.random() * 4) + 5;
    },
    btnHandler() {
      this.$router.push({ path: '/' });
    },
  },
  created() {
    this.isErrorPage = this.$router?.currentRoute?.path !== '/not_found';
  },
  mounted() {
    this.randomImageIndex();
    window.addEventListener('resize', this.resizeWindowEventHandler);
  },
  unmounted() {
    window.removeEventListener('resize', this.resizeWindowEventHandler);
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/styles/scss/mixins.scss';

.error-page-component {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @include wide_tablet {
    align-items: flex-start;
  }
  .error-page-container {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 24px 0;
    align-items: center;
    @media screen and (min-width: 1920px) {
      height: 100%;
    }
    @include wide_tablet {
      width: 100%;
      padding: 24px;
      gap: 16px;
      height: calc(100vh - 48px - 56px);
    }
    @include phone {
      gap: 8px;
    }
    .background {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 16px;
      @media screen and (min-width: 1920px) {
        width: 1500px;
      }
      @media screen and (min-width: 1366px) and (max-width: 1919px) {
        width: 1020px;
      }
      @include wide_tablet {
        max-height: calc(100% - 220px);
      }
    }
    .ai-block {
      position: absolute;
      top: 56px;
      right: 56px;
      background: rgba(0, 0, 0, 0.5);
      color: var(--color-text-contrast);
      border-radius: 44px;
      display: flex;
      gap: 4px;
      font-size: 12px;
      line-height: 16px;
      padding: 4px 8px;
      white-space: nowrap;
      @media screen and (min-width: 2560px) {
        left: 56px;
        right: inherit;
        top: calc(50% - 188px);
      }
      @include phone {
        @include centered(x);
        right: inherit;
      }
    }
    .info-block {
      padding: 24px;
      border-radius: 16px;
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      bottom: 56px;
      left: 56px;
      display: flex;
      flex-direction: column;
      @media screen and (min-width: 2560px) {
        @include centered(y);
        bottom: initial;
      }
      @include wide_tablet {
        position: static;
        width: 100%;
        align-items: center;
      }
      @include phone {
        align-items: start;
      }
      .title {
        margin-bottom: 12px;
        color: var(--color-text-contrast);
        font-size: 32px;
        font-weight: 500;
        line-height: 40px;
        @include phone {
          font-size: 20px;
          line-height: 28px;
        }
      }
      .message {
        margin-bottom: 24px;
        color: var(--color-text-contrast);
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        @media screen and (min-width: 2560px) {
          font-size: 28px;
          font-weight: 500;
          line-height: 36px;
        }
        @include phone {
          font-size: 14px;
          line-height: 20px;
        }
      }
      .button {
        width: 100%;
      }
    }
  }
}
</style>
